// extracted by mini-css-extract-plugin
export default {"textCell":"TextCell_textCell__qGCJj","textCellTooltip":"TextCell_textCellTooltip__gi3+K"};